// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip-38f2d","white":"white-38f2d","grey":"grey-38f2d","darkgrey":"darkgrey-38f2d","primary":"primary-38f2d","arrow":"arrow-38f2d","shine":"shine-38f2d"};